@import "../../theme/global";

lar-app {
  user-select: none;
  background-color: $background-color;
  color: $text-color;
  font-family: var(--lar-font-family, inherit);
  display: block;
  position: relative !important;

  flex: 1;

  width: 100%;
  height: 100%;

  /* stylelint-disable */
  margin: 0 !important;

  padding: 0 !important;
  /* stylelint-enable */
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position;
  overscroll-behavior: contain;
  overflow: auto;
}
